module.exports = __webpack_public_path__ + "assets/images/announcement-very-high-sensitivity.png";